import React from 'react';
import PropTypes from 'prop-types';
import { downloadAttachment } from './actions';
import DownloadIcon from '@icons/download-icon';
import { Button } from '@mui';
import './download-all.scss';

const DownloadAll = ({ attachments }) => {
  const download = () => {
    for (let index = 0; index < attachments.length; index += 1) {
      setTimeout(() => {
        downloadAttachment(attachments[index]);
      }, (index + 1) * 1000);
    }
  };

  return (
    // The click handler belongs on the real, already keyboard-accessible Button below, not on
    // this wrapper - putting it here too would nest a second interactive element inside it.
    <div styleName="container">
      <Button size="small" onClick={download} startIcon={<DownloadIcon />} style={{ textTransform: 'none' }}>
        Download all
      </Button>
    </div>
  );
};

DownloadAll.propTypes = {
  attachments: PropTypes.array
};

export default DownloadAll;
